
import React, { Component } from 'react';
import PropTypes from 'prop-types';

const defaultSize = '';

class Select extends Component {
    render() {
        const { name, value='default', options, onSelectOption, show, placeholder, noPlaceholder } = this.props;
        if (!options) {
            return null;
        }
        return (
                <select name={ name }
                    key={ name }
                    value={ value }
                    onChange={ (event) => onSelectOption(event.target.value) }>
                    { !noPlaceholder &&
                      <option value='default'>{placeholder || "Please select an option"}</option> }
                    {
                        options
                            .map((option, index) => {
                                return (
                                    <option
                                        key={ index }
                                        value={ option.value }
                                        >
                                        {show ? option[show] : `${option.name} - ${option.value}`}
                                    </option>
                                )
                            })
                    }
                </select>
            );
    }
}

Select.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string
    })),
    onSelectOption: PropTypes.func
};

export default Select;
